// src/sot/primitives/AvatarHeaderProfile.jsx
import React from "react";

// This primitive owns the profile avatar frame. The borderless artwork keeps
// the empty state to one frame instead of nesting the framed legacy SVG.
const PROFILE_AVATAR_FALLBACK = "/icons/Profile_Avatar_borderless.svg";

/**
 * AvatarHeaderProfile
 * Read-only avatar shown on DoctorProfile screen.
 */
export default function AvatarHeaderProfile({
  src,
  verificationBadgeSrc = "",
  verificationBadgeAlt = "",
  mobileOffsetClassName = "pt-[144px] sm:pt-[148px]",
  dataTestId,
}) {
  const safeSrc = src || PROFILE_AVATAR_FALLBACK;
  const isFallback = safeSrc === PROFILE_AVATAR_FALLBACK;

  return (
    <div className="pointer-events-none absolute inset-0">
      <div
        className={[
          "afrimed-rail afrimed-rail--comfortable",
          mobileOffsetClassName,
          "md:pt-[224px] lg:pt-[248px]",
        ].join(" ")}
      >
        <div className="pointer-events-auto inline-flex relative">
          {/* OUTER FRAME */}
          <div
            data-testid={dataTestId}
            className="
              afrimed-profile-avatar
              h-20 w-20 md:h-[150px] md:w-[150px]
            "
          >
            {/* INNER IMAGE */}
            <img
              src={safeSrc}
              alt="Doctor profile"
              className={isFallback ? "object-contain" : "object-cover"}
              draggable="false"
            />
          </div>

          {verificationBadgeSrc ? (
            <span
              className="
                absolute -bottom-1 -right-1 md:bottom-1 md:right-1
                inline-flex items-center justify-center
                rounded-full
              "
            >
              <img
                src={verificationBadgeSrc}
                alt={verificationBadgeAlt || "Verification status"}
                className="h-5 w-5 md:h-6 md:w-6"
                draggable="false"
              />
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
